
export class Alarmcodes {
  public id: number;
  public code: number;
  public description: string;
  public tts: string;
  public bodyid: string;
  public tag: string;

  constructor(
    id: number,
    code: number,
    description: string,
    tts: string,
    bodyid: string,
    tag: string
  ) {
    this.id = id;
    this.code = code;
    this.description = description;
    this.tts = tts;
    this.bodyid = bodyid;
    this.tag = tag;
  }

}
